'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHttp = function MdHttp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.9 19.1v-1.6h-3.4v1.6h3.4z m0-4.1c1.3 0 2.5 1.2 2.5 2.5v1.6c0 1.4-1.2 2.5-2.5 2.5h-3.4v3.4h-2.5v-10h5.9z m-15 2.5v-2.5h7.5v2.5h-2.5v7.5h-2.5v-7.5h-2.5z m-9.3 0v-2.5h7.5v2.5h-2.5v7.5h-2.5v-7.5h-2.5z m-4.1 0.9v-3.4h2.5v10h-2.5v-4.1h-3.4v4.1h-2.5v-10h2.5v3.4h3.4z' })
        )
    );
};

exports.default = MdHttp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/http.js
// module id = 3429
// module chunks = 168707334958949